import React from 'react';
import { useParams } from 'react-router-dom';
import TEMPLATE_REGISTRY from '../templates/TemplateRegistry';

/* DEV-only template preview. Renders any registered template with demo
   data so the layout can be checked in isolation. Not linked anywhere. */
const DEMO = {
  slug: 'demo',
  bride: 'Анна',
  groom: 'Иван',
  wedding_date: '2026-06-07',
  wedding_time: '17:00',
  invitation_text:
    'С огромным волнением и радостью хотим пригласить вас на ужин в честь нашего бракосочетания!\n\nВ этот особенный день мы будем счастливы видеть каждого из вас, чтобы разделить волшебство момента.\n\nПожалуйста, подтвердите своё присутствие до 20.04.2026.',
  cover_photos: [{ url: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800' }],
  footer_photo: { url: 'https://images.unsplash.com/photo-1606800052052-a08af7148866?w=800' },
  dresscode_palette: ['#2B3C2C', '#566B4D', '#8FA77E', '#C8D6BC', '#ECF2E6', '#FFD58B'],
  dresscode_photos: [
    { url: 'https://images.unsplash.com/photo-1594552072238-b8a33785b261?w=400' },
    { url: 'https://images.unsplash.com/photo-1583391733956-6c78276477e2?w=400' },
    { url: 'https://images.unsplash.com/photo-1566174053879-31528523f8ae?w=400' },
    { url: 'https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=400' },
  ],
  venues: [{ name: 'Ресторан «Веранда»', address: 'город Москва, Большой Афанасьевский переулок, дом. 11–13' }],
  schedule: [
    { time: '17:00', name: 'Сбор гостей, велком и фотосессия с гостями' },
    { time: '18:00', name: 'Развлекательная программа' },
    { time: '19:30', name: 'Встречаем закат' },
    { time: '20:00', name: 'Праздничный ужин с тостами' },
    { time: '21:30', name: 'Свадебный торт и чай' },
    { time: '23:00', name: 'Пора домой' },
  ],
  wishlist: [
    { id: 'w1', name: 'Набор постельного белья', price: '1900' },
    { id: 'w2', name: 'iPhone 17 Pro Max', price: '1900' },
    { id: 'w3', name: 'Кофемашина', price: '1900' },
  ],
  block_content: {
    header: { subtitle: 'Любовь начинается здесь' },
    message: { title: 'Дорогие гости' },
    footer: { quote: 'Спасибо, что вы с нами' },
  },
  blocks: ['menu', 'map', 'schedule', 'palette', 'rsvp', 'survey', 'message', 'wishlist', 'countdown', 'calendar'],
  is_paid: true,
};

export default function DevPreview() {
  const { key } = useParams();
  const T = TEMPLATE_REGISTRY[key];
  if (!T) return <div style={{ padding: 40 }}>Нет шаблона «{key}»</div>;
  return <T project={DEMO} design={{}} isPreview={false} />;
}
